import { ChainId, Token } from '@sushiswap/core-sdk'

export const USDC = new Token(ChainId.ARBITRUM, '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', 6, 'USDC', 'USD Coin')
export const WBTC = new Token(
  ChainId.ARBITRUM,
  '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
  8,
  'WBTC',
  'Wrapped Bitcoin'
)
export const USDT = new Token(ChainId.ARBITRUM, '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', 8, 'USDT', 'Tether USD')
export const MIM = new Token(
  ChainId.ARBITRUM,
  '0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A',
  18,
  'MIM',
  'Magic Internet Money'
)
export const SPELL = new Token(
  ChainId.ARBITRUM,
  '0x3E6648C5a70A150A88bCE65F4aD4d506Fe15d2AF',
  18,
  'SPELL',
  'Spell Token'
)
export const ICE = new Token(ChainId.ARBITRUM, '0xCB58418Aa51Ba525aEF0FE474109C0354d844b7c', 18, 'ICE', 'ICEToken')
export const gOHM = new Token(
  ChainId.ARBITRUM,
  '0x8D9bA570D6cb60C7e3e0F31343Efe75AB8E65FB1',
  18,
  'gOHM',
  'Governance OHM'
)
export const DUSD = new Token(
  ChainId.ARBITRUM,
  '0xF0B5cEeFc89684889e5F7e0A7775Bd100FcD3709',
  6,
  'DUSD',
  'DigitalDollar'
)
export const FLUID = new Token(ChainId.ARBITRUM, '0x876Ec6bE52486Eeec06bc06434f3E629D695c6bA', 18, 'FLUID', 'FluidFi')
export const MAGIC = new Token(ChainId.ARBITRUM, '0x539bdE0d7Dbd336b79148AA742883198BBF60342', 18, 'MAGIC', 'MAGIC')
export const FRAX = new Token(ChainId.ARBITRUM, '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F', 18, 'FRAX', 'Frax')
export const FXS = new Token(ChainId.ARBITRUM, '0x9d2F299715D94d8A7E6F5eaa8E654E8c74a988A7', 18, 'FXS', 'Frax Share')
export const STG = new Token(ChainId.ARBITRUM, '0x6694340fc020c5E6B96567843da2df01b2CE1eb6', 18, 'STG', 'StargateToken')
